import type { GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200 } from '@fukuri-admins/apis/client/gen/model';
import { CARD_BRAND_LABELS } from '../../constants';
import type { ContractInfoPaymentMethodPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ContractInfoPaymentMethodPresentation>;

type Args = {
  /** Stripe 既定カード情報。null = 未登録（404） */
  data: GetApiV1ThreeLetterCodeClientAdminsStripeCreditCard200 | null;
};

type IConvertToPresentationProps = (args: Args) => PresentationProps;

/**
 * カードブランドの日本語表示名を取得する
 *
 * 未知の brand 値の場合は元の値をそのまま返す
 *
 * @param brand - Stripe の card brand 値
 */
const convertBrandLabel = (brand: string): string => CARD_BRAND_LABELS[brand] ?? brand;

/**
 * Stripe 既定カード情報を ContractInfoPaymentMethodPresentation の Props に変換する
 *
 * data が null（カード未登録: 404）の場合、cardLabel は undefined を返す
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => ({
  cardLabel: data
    ? `${convertBrandLabel(data.stripe_credit_card.brand)}（‥‥${data.stripe_credit_card.last4}）`
    : undefined,
});
